import { render, staticRenderFns } from "./ProcedimentosOrcados.vue?vue&type=template&id=4bc30ca6&scoped=true&"
import script from "./ProcedimentosOrcados.vue?vue&type=script&lang=js&"
export * from "./ProcedimentosOrcados.vue?vue&type=script&lang=js&"
import style0 from "./ProcedimentosOrcados.vue?vue&type=style&index=0&id=4bc30ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc30ca6",
  null
  
)

export default component.exports